import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9a024e98e8d92a0bbad10e65dd676b47.jpg"
          alt="Bureau professionnel"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A2540]/90 via-[#0A2540]/70 to-[#0A2540]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-28 pb-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 text-white/80 text-xs uppercase tracking-widest mb-8">
            Conseil en affaires &amp; gestion
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
            Conseil en gestion et développement d&apos;entreprise
          </h1>
          <p className="text-lg md:text-xl text-white/75 leading-relaxed mb-10 max-w-xl">
            BOBROWSKA accompagne les entrepreneurs et les entreprises dans le développement et l&apos;organisation de leur activité. L&apos;objectif est de proposer des solutions simples, efficaces et adaptées à chaque situation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-white text-[#0A2540] font-semibold text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap"
            >
              Contactez-nous
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/a-propos"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-white/40 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
            >
              En savoir plus
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-lg"></i>
        </span>
      </div>
    </section>
  );
}
